import React, { useEffect } from 'react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useError } from '@/contexts/ErrorContext';

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles: Array<'super_admin' | 'marketing_agent' | 'staff'>;
  fallback?: ReactNode;
  redirectUnauthorized?: boolean;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  allowedRoles,
  fallback = null,
  redirectUnauthorized = false,
}) => {
  const { user } = useAuth();
  const { showError } = useError();
  const hasAccess = user ? allowedRoles.includes(user.role) : false;

  useEffect(() => {
    if (user && !hasAccess && redirectUnauthorized) {
      showError('Unauthorized Access');
    }
  }, [hasAccess, redirectUnauthorized, showError, user]);

  if (!user) {
    return <>{fallback}</>;
  }

  if (!hasAccess) {
    if (redirectUnauthorized) {
      return <Navigate to="/dashboard" replace />;
    }

    return <>{fallback}</>;
  }

  return <>{children}</>;
};